import Vue from "vue";
import purchaseOrdersTransformer from "@/transformers/purchase/completeOCs";

export default (warehouseId) => {
  const finalUrl = warehouseId ? `purchase/list_orders_simple/${warehouseId}/` : 'purchase/list_orders_simple/'
  return Vue.$http
    .get(finalUrl)
    .then((response) => {
      const data = purchaseOrdersTransformer.fetchCollection(response.data)
      return data
    })
    .catch((error) => {
      const response = error.response
      if (response && response.status !== 404) {
        throw error
      }
    })
};


// WEBPACK FOOTER //
// ./src/services/purchase/fetchCompleteOCs.js